import React, { Component } from 'react';
// import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import LoginForm from './LoginForm'
import '../../assets/css/adminLogin.css'
import {
    Redirect
} from 'react-router-dom'
import {
    submitLogin,
    unauthorize
} from '../../actions/LoginAction'
import{
    ROUTE_ADMIN_LOGIN,
    ROUTE_REQUISITION_LIST,
    // ROUTE_ADMIN_MAIN
} from '../../utils/routes'
import {
    Paper 
} from '@material-ui/core'
import * as Sentry from '@sentry/browser'

Sentry.init({
   dsn: "https://8b7fd3762e754bab8c1c1e62dd17f0db@sentry.io/1388765"
});

class AdminLogin extends Component {

    componentWillMount() {
        /**
         * resest unauthorize field in reducer
         */
        this.props.unauthorize()
    }

    componentDidCatch(error, errorInfo) {
        Sentry.withScope(scope => {
          Object.keys(errorInfo).forEach(key => {
            scope.setExtra(key, errorInfo[key]);
          });
          Sentry.captureException(error);
        });
    }

    render() {

        const {login: {requisition} } = this.props

        return(
            <div className="Main">
                {
                    requisition.login_success ? (
                        <Redirect 
                            from={ROUTE_ADMIN_LOGIN} 
                            to={ROUTE_REQUISITION_LIST}
                        />
                    ):(
                        <div className="Container">
                            <Paper className="Paper">
                                <LoginForm 
                                    onSubmit={this.handleSubmit}/>
                            </Paper>
                        </div>
                    )
                }

                
            </div>
        )
    }

    handleSubmit = (prop) => {
        this.props.submitLogin({
            email: prop.email, 
            password: prop.password, 
            cookies: this.props.cookies 
        })
    }

}

// AdminLogin.propTypes = {
//     //classes: PropTypes.object.isRequired
// }

const mapDispatchToProps = (dispatch) => ({
    submitLogin: (prop) => {
        dispatch(
            submitLogin(prop)
        )
    },
    unauthorize: () => {
        dispatch(
            unauthorize()
        )
    }

  })
  
const mapStateToProps = (state, ownProps) => ({
    login: state,
    cookies: ownProps.cookies
})

export default connect(mapStateToProps, mapDispatchToProps)(AdminLogin)